import { Text } from '@epam/promo';
import cloudImage from 'assets/icons/cloud.svg';
import botImage from 'assets/icons/bot-pic.svg';
import css from './BlankBlock.module.scss';
import { BlankBlockProps } from './BlankBlock.model';

const BlankBlock = ({ message, header }: BlankBlockProps) => (
  <div className={css.blank}>
    <div className={css.blank__container}>
      <img alt="A background" src={cloudImage} />
      <div className={css.blank__info}>
        <Text
          color="gray90"
          cx={css.blank__title}
          font="sans-semibold"
          fontSize="18"
          lineHeight="24">
          {header}
        </Text>
        <Text
          color="gray80"
          cx={css.body}
          font="sans"
          fontSize="14"
          lineHeight="18">
          {message}
        </Text>
      </div>
    </div>
    <img alt="Bot" className={css.blank__image} src={botImage} />
  </div>
);

BlankBlock.defaultProps = {
  message: 'Please add new data',
  header: 'Nothing to display yet',
};

export { BlankBlock };
